import React from 'react';
import WeekCalendarItem from './week-calendar-item';
import './week-calendar-row-cell.css';

const WeekCalendarRowCell = ({ ...props }) => {
    const { items, onItemClick, className = '', dayIndex, frames, stretchableIds, stretchMeasured } = props;
    const divItems =
        items &&
        items.map((item) => {
            if (frames && frames[String(item.id)]) return null;
            const pending = Boolean(stretchableIds && stretchableIds.has(item.id) && !stretchMeasured);
            return (
                <WeekCalendarItem
                    {...item}
                    key={`item-${item.id}`}
                    dayIndex={dayIndex}
                    pending={pending}
                    onItemClick={onItemClick}
                />
            );
        });

    return (
        <div
            className={`week-calendar-row-cell${className ? ` ${className}` : ''}`}
            data-day={dayIndex == null ? undefined : dayIndex}
        >
            {props.children}
            {divItems}
        </div>
    );
};

export default WeekCalendarRowCell;
